import React, { useState, useMemo, useEffect } from 'react';
import { Space, Input, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ProjectCardGrid from './ProjectCardGrid';
const { Search } = Input; 

const ProjectsSection = ({
    projects = [],
    loading = false,
  onAction,
  onTagClick,
  onTabChange,
  onPageChange,
  defaultTab = 'all',
  pageSize = 12,
  totalItems,
  currentPage,
  showTabs = true,
  showSearch = true,
  tabItems = [],
  emptyText,
  emptyDescription
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar projetos baseado na busca e tab ativa
  const filteredProjects = useMemo(() => {
    let filtered = projects;

    // Aplicar filtro de busca
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(project =>
        project.name?.toLowerCase().includes(term) ||
        project.description?.toLowerCase().includes(term)
      );
    }

    // Aplicar filtro de tab se callback de filtro foi fornecido
    if (onTabChange && activeTab !== 'all') {
      filtered = onTabChange(activeTab, filtered);
    }

    return filtered;
  }, [projects, searchTerm, activeTab, onTabChange]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        {showTabs && tabItems.length > 0 ? (
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            items={tabItems}
            style={{ flex: 1, minWidth: 0 }}
          />
        ) : null}

        {showSearch ? (
          <div style={{ minWidth: 280 }}>
            <Search
              placeholder="Buscar projetos..."
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                borderRadius: 8,
              }}
            />
          </div>
        ) : null}
      </div>

      <ProjectCardGrid
        projects={filteredProjects}
        loading={loading}
        onAction={onAction}
        onTagClick={onTagClick}
        pageSize={pageSize}
        onPageChange={onPageChange}
        totalItems={totalItems}
        currentPage={currentPage}
        emptyText={emptyText}
        emptyDescription={emptyDescription}
      />
    </Space>
  );
};

export default ProjectsSection; 
